import React, { useState } from "react";
import FundraiserHeader from "../common/FundraiserHeader";
import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import {
  FaInstagram,
  FaFacebook,
  FaYoutube,
  FaLinkedin,
  FaTiktok,
} from "react-icons/fa";
import axios from "../../../utils/axios";
import toast from "../../../utils/toast";
import Loader from "../../common/Loader";
import PhoneFormInput from "../../common/PhoneInput";
import "./comingsoon.scss";

const ComingSoonPage = () => {
  const [phone, setPhone] = useState("");
  const [offersFeedback, setOffersFeedback] = useState("");
  const [brandsFeedback, setBrandsFeedback] = useState("");
  const [referralSource, setReferralSource] = useState("");
  const [generalFeedback, setGeneralFeedback] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || phone.trim().length <= 4) {
      toast.error("Please enter a valid mobile number.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("waitlist", {
        phone: phone.trim(),
        surveyAnswers: {
          offersFeedback: offersFeedback.trim(),
          brandsFeedback: brandsFeedback.trim(),
          referralSource: referralSource,
          generalFeedback: generalFeedback.trim(),
        },
      });

      if (response.data?.success) {
        toast.success(response.data.message || "Subscribed successfully!");
        setSubmitted(true);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      toast.error(err.message || "Failed to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="coming-soon-page w-full min-h-screen flex flex-col justify-between">
      {loading && <Loader />}

      {/* Reused Brand Header */}
      <FundraiserHeader brandLogo={null} />

      <main className="coming-soon-main flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="coming-soon-card w-full max-w-[650px] bg-white rounded-3xl p-8 sm:p-12 shadow-xl border border-[#d8e2ec]">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col gap-8">
              {/* Title & Message */}
              <div className="text-center flex flex-col gap-4">
                <h1 className="coming-soon-title text-[#00ADEF] font-poppins font-extrabold tracking-tight">
                  We're launching soon!
                </h1>
                <p className="coming-soon-subtitle text-gray-500 text-base sm:text-lg leading-relaxed font-poppins font-light">
                  Thanks for checking out Swoodle. We're putting the finishing
                  touches on the platform. Leave your mobile number below and
                  we'll send you a message as soon as we go live.
                </p>
              </div>

              {/* Mobile Input Field */}
              <div className="form-group flex flex-col gap-2">
                <label
                  htmlFor="phone"
                  className="text-sm font-semibold text-[#08264a] font-poppins"
                >
                  Mobile Number <span className="text-red-500">*</span>
                </label>
                <PhoneFormInput
                  name="phone"
                  value={phone}
                  setFieldValue={(name, value) => setPhone(value)}
                  placeholder="e.g. +61 400 000 000"
                  containerClass="coming-soon-phone-input"
                />
                {/* <p className="text-xs text-gray-400 font-poppins mt-1">
                  We collect mobile numbers for SMS and WhatsApp notifications because they achieve much higher engagement rates.
                </p> */}
              </div>

              <hr className="border-t border-[#d8e2ec]" />

              {/* Survey Section */}
              <div className="survey-section flex flex-col gap-6">
                <div className="text-center sm:text-left">
                  <h2 className="survey-heading text-lg font-bold text-[#08264a] font-poppins">
                    Help Shape Swoodle (Quick Survey)
                  </h2>
                  <p className="text-sm text-gray-400 font-poppins mt-1">
                    Your feedback will help us partner with your favorite local
                    brands and customize our deals!
                  </p>
                </div>

                {/* Q1 */}
                <div className="form-group flex flex-col gap-2">
                  <label
                    htmlFor="q1"
                    className="text-sm font-semibold text-[#08264a] font-poppins"
                  >
                    1. What types of offers or deals would you like to see on
                    Swoodle?
                  </label>
                  <textarea
                    id="q1"
                    rows="2"
                    placeholder="e.g., Buy-one-get-one dining, gym memberships, local groceries..."
                    value={offersFeedback}
                    onChange={(e) => setOffersFeedback(e.target.value)}
                    className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                  />
                </div>

                {/* Q2 */}
                <div className="form-group flex flex-col gap-2">
                  <label
                    htmlFor="q2"
                    className="text-sm font-semibold text-[#08264a] font-poppins"
                  >
                    2. Which brands, businesses, or services would you like us
                    to partner with?
                  </label>
                  <textarea
                    id="q2"
                    rows="2"
                    placeholder="e.g., Local cafes, retail chains, fitness centers..."
                    value={brandsFeedback}
                    onChange={(e) => setBrandsFeedback(e.target.value)}
                    className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                  />
                </div>

                {/* Q3 */}
                <div className="form-group flex flex-col gap-2">
                  <label
                    htmlFor="q3"
                    className="text-sm font-semibold text-[#08264a] font-poppins"
                  >
                    3. How did you hear about us?
                  </label>
                  <select
                    id="q3"
                    value={referralSource}
                    onChange={(e) => setReferralSource(e.target.value)}
                    className="survey-select w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins bg-white focus:outline-none focus:border-[#007aff]"
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    <option value="Social Media">Social Media</option>
                    <option value="Friend or Family">Friend or Family</option>
                    <option value="Fundraiser Invitation">
                      Fundraiser Invitation
                    </option>
                    <option value="Online Search">Online Search</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* Q4 */}
                <div className="form-group flex flex-col gap-2">
                  <label
                    htmlFor="q4"
                    className="text-sm font-semibold text-[#08264a] font-poppins"
                  >
                    4. Is there anything else you'd like to see on the platform?
                  </label>
                  <textarea
                    id="q4"
                    rows="2"
                    placeholder="Describe any other features or feedback..."
                    value={generalFeedback}
                    onChange={(e) => setGeneralFeedback(e.target.value)}
                    className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="notify-button w-full py-4 rounded-xl text-white font-poppins font-bold text-base transition-all"
              >
                Notify Me
              </button>
            </form>
          ) : (
            /* Success State */
            <div className="text-center flex flex-col items-center gap-6 py-8">
              <div className="success-icon-wrap w-20 h-20 bg-[#e0f2fe] rounded-full flex items-center justify-center text-[#007aff] animate-pulse">
                <svg
                  className="w-10 h-10"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <div className="flex flex-col gap-3">
                <h1 className="coming-soon-title text-[#08264a] font-poppins font-extrabold tracking-tight">
                  You're on the list!
                </h1>
                <p className="text-gray-500 text-base leading-relaxed font-poppins font-light max-w-md">
                  Thank you for subscribing and sharing your feedback. We've
                  added you to our early access waitlist and will send a
                  notification to <strong>{phone}</strong> as soon as Swoodle
                  launches!
                </p>
              </div>
              <button
                onClick={() => {
                  setPhone("");
                  setOffersFeedback("");
                  setBrandsFeedback("");
                  setReferralSource("");
                  setGeneralFeedback("");
                  setSubmitted(false);
                }}
                className="notify-button px-8 py-3 rounded-xl text-white font-poppins font-bold text-sm transition-all mt-4"
              >
                Back
              </button>
            </div>
          )}
        </div>
      </main>

      {/* Swoodle Reused Brand Footer */}
      <footer className="fundraiser-brand-footer w-full bg-[#002042] py-8 text-white mt-12">
        <div className="footer-container w-[90%] max-w-[1200px] mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="footer-left flex flex-col items-center md:items-start gap-3">
            <img
              src={SwoodleLogo}
              alt="Swoodle"
              className="footer-logo w-[150px]"
            />
          </div>
          <div className="footer-right flex flex-col items-center md:items-end gap-3">
            <span className="footer-follow-us text-xs font-bold tracking-widest font-poppins text-gray-400">
              FOLLOW US
            </span>
            <div className="footer-social-links flex gap-3">
              <a
                href="https://www.instagram.com/swoodleau/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-white hover:text-[#007aff] hover:border-[#007aff] transition-all"
              >
                <FaInstagram className="text-sm" />
              </a>
              <a
                href="https://www.facebook.com/swoodleau/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-white hover:text-[#007aff] hover:border-[#007aff] transition-all"
              >
                <FaFacebook className="text-sm" />
              </a>
              <a
                href="https://www.youtube.com/@swoodleau"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-white hover:text-[#007aff] hover:border-[#007aff] transition-all"
              >
                <FaYoutube className="text-sm" />
              </a>
              <a
                href="https://www.linkedin.com/company/swoodleau/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-white hover:text-[#007aff] hover:border-[#007aff] transition-all"
              >
                <FaLinkedin className="text-sm" />
              </a>
              <a
                href="https://www.tiktok.com/@swoodleau"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-white hover:text-[#007aff] hover:border-[#007aff] transition-all"
              >
                <FaTiktok className="text-sm" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ComingSoonPage;
